const stripTrailingSlash = (value) => value.replace(/\/$/, '');

const apiBaseUrl = stripTrailingSlash(
  process.env.REACT_APP_API_BASE_URL || '/api'
);

const defaultWebSocketUrl = (path) => {
  if (process.env.REACT_APP_API_BASE_URL && /^https?:\/\//.test(apiBaseUrl)) {
    const url = new URL(apiBaseUrl);
    url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
    const apiPath = stripTrailingSlash(url.pathname);
    url.pathname = `${apiPath.replace(/\/api$/, '')}${path}`;
    return url.toString();
  }

  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}${path}`;
};

export const API_BASE_URL = apiBaseUrl;

export const WS_BASE_URL = stripTrailingSlash(
  process.env.REACT_APP_WS_BASE_URL || defaultWebSocketUrl('/ws/games')
);

export const WS_LOBBY_URL = (
  process.env.REACT_APP_WS_LOBBY_URL || defaultWebSocketUrl('/ws/lobby/')
);

export const WS_GIZMOS_BASE_URL = stripTrailingSlash(
  process.env.REACT_APP_WS_GIZMOS_BASE_URL || defaultWebSocketUrl('/ws/gizmos')
);

export const WS_GIZMOS_LOBBY_URL = (
  process.env.REACT_APP_WS_GIZMOS_LOBBY_URL || defaultWebSocketUrl('/ws/gizmos/lobby/')
);
